<div class="gender-chart-container" *ngIf="!noDataAvailable">
  <div class="chart-title">
    <span>{{chartTitle}}</span>
  </div>
  <div class="legend-item flex-auto female" [ngClass]="{'is-hidden': !isVisibleLegend('female')}">
    <a class="legend-item-wrapper" (click)="clickLegend('female')" (mouseover)="hoverLegend('female')">
      <span class="gender-legend-percent">{{genderPercent('female') | percentNumberSuffix}}</span>
      <div class="gender-legend-title">
        <span>{{'INFLUENCER.demographic.gender_chart.female' | translate}}</span>
        <div class="gender-legend-icon" [style.background-color]="isVisibleLegend('female') ? femaleColor : null"></div>
      </div>
    </a>
  </div>
  <div class="chart-content" [ngStyle]="{'max-width': width ? width + 'px' : '60%'}">
    <chart class="chart-container"
           [options]="options" (load)="saveInstance($event.context)">
    </chart>
  </div>
  <div class="legend-item flex-auto male" [ngClass]="{'is-hidden': !isVisibleLegend('male')}">
    <a class="legend-item-wrapper" (click)="clickLegend('male')" (mouseover)="hoverLegend('male')">
      <span class="gender-legend-percent">{{genderPercent('male') | percentNumberSuffix}}</span>
      <div class="gender-legend-title">
        <span>{{'INFLUENCER.demographic.gender_chart.male' | translate}}</span>
        <div class="gender-legend-icon" [style.background-color]="isVisibleLegend('male') ? maleColor : null"></div>
      </div>
    </a>
  </div>
</div>
<div *ngIf="titleTooltip" class="chart-title-tooltip">
  <achoo-icon-tooltip [tooltipMsg]="titleTooltip"></achoo-icon-tooltip>
</div>
<div class="gender-chart-container" *ngIf="noDataAvailable">
  <div class="chart-title">
    <span>{{chartTitle}}</span>
  </div>
  <div class="chart-placeholder">
    <div class="chart-placeholder-content" [innerHTML]="'INFLUENCER.CHART.DATA_NOT_AVAILABLE' | translate"></div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/demographic/demographic-gender-chart/demographic-gender-chart.component.html